import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_TEAM_REPORT_CONFIG = 'FETCH_ANALYTIC_TEAM_REPORT_CONFIG';
export const fetchAnalyticTeamReportConfigAction = createAction(FETCH_ANALYTIC_TEAM_REPORT_CONFIG);